import React from 'react';
import PropTypes from 'prop-types';

import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Type, { Title, Body } from '@nerdwallet/react-typography';
import AuthFlowButton from '@nerdwallet/react-auth-flow-button';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import appConfig from '@nerdwallet/app-config';
import Image from '@nerdwallet/react-image';
import { colors } from '@nerdwallet/base-styles/variables';
import { CenteredContainer } from '@nerdwallet/react-layout';

const AccountModule = ({
  eyebrow,
  title,
  description,
  ctaText,
  imageSrcDesktop,
  imageSrcMobile,
  trkCopy,
}) => {
  const imageDesktop = (
    <Image
      className="acct__img-desktop"
      src={imageSrcDesktop}
      alt="A simplified NerdWallet account dashboard page showing credit score and net worth information with close-ups on spending"
      backgroundColor={colors.transparent}
    />
  );

  const imageTablet = (
    <Image
      className="image"
      src={imageSrcDesktop}
      alt="A simplified NerdWallet account dashboard page showing credit score and net worth information with close-ups on spending"
      backgroundColor={colors.transparent}
    />
  );

  const imageMobile = (
    <Image
      className="image"
      src={imageSrcMobile}
      alt="The NerdWallet mobile app, displaying a user’s net worth and cash flow with a close-up of account allocation"
      backgroundColor={colors.transparent}
    />
  );

  return (
    <BedrockImpression entityName="member_registration_container">
      <ElementImpression
        elementDomType="div"
        elementName="Membership"
        id="membership-container"
      >
        <CenteredContainer className="acct">
          <div className="acct__left">
            <div className="acct__copy">
              <Type light uppercase size={1} bold className="acct__eyebrow">
                {eyebrow}
              </Type>
              <Title size="large" className="acct__heading">
                {title}
              </Title>
              <div className="acct__img-mobile">{imageMobile}</div>
              <Body className="acct__description">{description}</Body>
            </div>
            <div className="acct__copy-container">
              <div className="acct__copy">
                <AuthFlowButton
                  flowPreset="onboardingGeneric"
                  flowProps={{
                    trk: {
                      trk_copy: trkCopy,
                    },
                  }}
                  className="acct__join-btn"
                  entityName="acct_module_registration"
                >
                  {ctaText}
                </AuthFlowButton>
              </div>
            </div>
          </div>
          <div className="acct__img-tablet">{imageTablet}</div>
          <div className="acct__img-desktop-wrapper">{imageDesktop}</div>
        </CenteredContainer>
      </ElementImpression>
    </BedrockImpression>
  );
};

AccountModule.propTypes = {
  ctaText: PropTypes.string,
  description: PropTypes.string,
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  trkCopy: PropTypes.string,
  imageSrcDesktop: PropTypes.string,
  imageSrcMobile: PropTypes.string,
};

AccountModule.defaultProps = {
  ctaText: 'Get started',
  imageSrcDesktop: `${appConfig.ASSETS_URL}/images/account_module_desktop_ab.svg`,
  imageSrcMobile: `${appConfig.ASSETS_URL}/images/account_module_mobile_ab.svg`,
};

export default AccountModule;
